"use client";

import { useState } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import Paper from "@mui/material/Paper";
import InputBase from "@mui/material/InputBase";
import CircularProgress from "@mui/material/CircularProgress";
import { ToastContainer, toast } from "react-toastify";
import MDBadge from "components/MDBadge";
import colors from "assets/theme/base/colors";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import DownloadIcon from "@mui/icons-material/Download";
import FilterListIcon from "@mui/icons-material/FilterList";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import Box from "@mui/material/Box";
import VoucherDialog from "../student_dashboard/Pages/VoucherDialog";
import "react-toastify/dist/ReactToastify.css";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import DeleteIcon from "@mui/icons-material/Delete";
import VerifiedIcon from "@mui/icons-material/Verified";
import VisibilityIcon from "@mui/icons-material/Visibility";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";

const { info } = colors;
const BASE_URL = process.env.REACT_APP_BASE_URL;
const token = sessionStorage.getItem("token");
import { hasAdmissionPermission } from "hooks/permissions";
import { Header } from "semantic-ui-react";

const BANKS = ["HBL", "UBL", "NBP", "BAL"];
const VOUCHER_TYPES = [
  { label: "All (Morning & Evening)", value: "all" },
  { label: "Morning", value: "semester-fee-morning" },
  { label: "Evening", value: "semester-fee-evening" },
];

const isVoucherCancelled = (voucher) => {
  if (!voucher) return false;
  const paymentMode = String(voucher.payment_mode || "").trim().toUpperCase();
  return Boolean(voucher.is_cancel) || paymentMode === "CANCELLED";
};

function SemesterVouchers() {
  const [voucherNumber, setVoucherNumber] = useState("");
  const [loading, setLoading] = useState(false);
  const [vouchers, setVouchers] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedVoucher, setSelectedVoucher] = useState(null);

  // Pay voucher modal states
  const [payModalOpen, setPayModalOpen] = useState(false);
  const [selectedBank, setSelectedBank] = useState("");
  const [transactionId, setTransactionId] = useState("");
  const [paymentDateTime, setPaymentDateTime] = useState("");
  const [payingVoucherCode, setPayingVoucherCode] = useState("");

  // Bulk pay modal states
  const [bulkPayModalOpen, setBulkPayModalOpen] = useState(false);
  const [csvFile, setCsvFile] = useState(null);
  const [csvData, setCsvData] = useState([]);
  const [csvErrors, setCsvErrors] = useState([]);
  const [bulkPayLoading, setBulkPayLoading] = useState(false);
  const [successVouchers, setSuccessVouchers] = useState([]);
  const [errorVouchers, setErrorVouchers] = useState([]);

  // Filter modal states
  const [filterModalOpen, setFilterModalOpen] = useState(false);
  const [filterToDate, setFilterToDate] = useState("");
  const [filterFromDate, setFilterFromDate] = useState("");
  const [filterBank, setFilterBank] = useState("");
  const [filterType, setFilterType] = useState("all");
  const [includeProcessing, setIncludeProcessing] = useState(false);

  // New filters for Filter Paid modal
  const [studentType, setStudentType] = useState(() =>
    localStorage.getItem("semester_filter_student_type") || "all"
  );
  const [fineType, setFineType] = useState(() =>
    localStorage.getItem("semester_filter_fine_type") || "all"
  );

  // New Filter Paid Not Pushed to SAP modal states
  const [filterNotPushedModalOpen, setFilterNotPushedModalOpen] =
    useState(false);
  const [filterNotPushedToDate, setFilterNotPushedToDate] = useState("");
  const [filterNotPushedFromDate, setFilterNotPushedFromDate] = useState("");
  const [filterNotPushedBank, setFilterNotPushedBank] = useState("");
  const [filterNotPushedType, setFilterNotPushedType] = useState("all");
  // New filters for Not Pushed modal
  const [filterNotPushedStudentType, setFilterNotPushedStudentType] =
    useState(() =>
      localStorage.getItem("semester_filter_not_pushed_student_type") || "all"
    );
  const [filterNotPushedFineType, setFilterNotPushedFineType] = useState(() =>
    localStorage.getItem("semester_filter_not_pushed_fine_type") || "all"
  );
  const [bulkSearchModalOpen, setBulkSearchModalOpen] = useState(false);
  const [bulkSearchInput, setBulkSearchInput] = useState("");
  const [bulkSearchLoading, setBulkSearchLoading] = useState(false);

  const [admissionVoucher, setAdmissionVoucher] = useState({});
  const [voucherModal, setVoucherModal] = useState(false);
  const [updateModalOpen, setUpdateModalOpen] = useState(false);
  const [amountToUpdate, setAmountToUpdate] = useState("");
  const [voucherToUpdate, setVoucherToUpdate] = useState(null);
  const [paymentImage, setPaymentImage] = useState(null);
  const [paymentImageBase64, setPaymentImageBase64] = useState("");
  const [imagePreview, setImagePreview] = useState("");

  const [viewLogsModalOpen, setViewLogsModalOpen] = useState(false);
  const [selectedVoucherForLogs, setSelectedVoucherForLogs] = useState(null);
  const [cancelledWarningOpen, setCancelledWarningOpen] = useState(false);
  const [cancelledWarningVoucher, setCancelledWarningVoucher] = useState(null);

  const warnIfCancelled = (voucher) => {
    if (!isVoucherCancelled(voucher)) return false;
    setCancelledWarningVoucher(voucher);
    setCancelledWarningOpen(true);
    return true;
  };

  // Export vouchers function
  const exportVouchers = () => {
    if (!vouchers || vouchers.length === 0) {
      toast.error("No vouchers to export");
      return;
    }
    try {
      // Define CSV headers
      const headers = [
        "Voucher Code",
        "Is Paid",
        "Due Date",
        "Amount",
        "Transaction ID",
        "Payment Date",
        "Applicant Name",
        "Applicant Phone",
        "Applicant CNIC",
        "SAP Status",
        "BP NO",
        "Payment Id",
        "Bank",
        "Program ID",
        "Program",
        "Department",
        "Cost Center",
        "Created Date",
      ];
      // Convert vouchers data to CSV format
      const csvData = vouchers.map((voucher) => [
        voucher.voucher_code || "",
        voucher.is_paid === 1 ? "Paid" : "Not Paid",
        voucher.due_date
          ? new Date(voucher.due_date).toLocaleDateString("en-GB", {
              day: "2-digit",
              month: "long",
              year: "numeric",
              timeZone: "Asia/Karachi",
            })
          : "",
        voucher.amount || "",
        voucher.transaction_id || "",
        voucher.payment_date || "",
        voucher.user_name || "",
        voucher.phone || "",
        voucher.cnic || "",
        voucher.is_added_to_sap === 1 ? "Pushed to SAP" : "Not Pushed",
        voucher.bp_no || "",
        voucher.payment_id || "",
        voucher.bank || "",
        voucher.program_id || "",
        voucher.program_name || "",
        voucher.department_name || "",
        voucher.cost_center || "",
        voucher.created_at
          ? new Date(voucher.created_at).toLocaleDateString("en-GB")
          : "",
      ]);
      // Combine headers and data
      const csvContent = [headers, ...csvData]
        .map((row) => row.map((field) => `"${field}"`).join(","))
        .join("\n");
      // Create and download the file
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute(
        "download",
        `semester_vouchers_${new Date().toISOString().split("T")[0]}.csv`
      );
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      toast.success(`Successfully exported ${vouchers.length} vouchers`);
    } catch (error) {
      console.error("Export error:", error);
      toast.error("Error exporting vouchers");
    }
  };

  const handleOpenUpdateModal = (voucher) => {
    if (warnIfCancelled(voucher)) return;
    setVoucherToUpdate(voucher);
    setAmountToUpdate(voucher.amount.toString());
    setUpdateModalOpen(true);
  };

  const handleUpdateAmount = async () => {
    if (!amountToUpdate || isNaN(Number.parseFloat(amountToUpdate))) {
      toast.error("Enter a valid amount");
      return;
    }
    try {
      const response = await fetch(
        `${BASE_URL}/fee_voucher/update_voucher_amount`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            voucher_id: voucherToUpdate.voucher_code,
            amount: Number.parseFloat(amountToUpdate),
          }),
        }
      );
      const data = await response.json();
      if (response.ok) {
        toast.success("Voucher amount updated successfully");
        setUpdateModalOpen(false);
        fetchVoucher(); // Refresh data
      } else {
        toast.error(data.error || "Failed to update amount");
      }
    } catch (error) {
      toast.error("Error updating voucher amount");
    }
  };

  const handleCloseVoucherModal = () => {
    setVoucherModal(false);
  };

  const handleOpenVoucherModal = async (code) => {
    try {
      const voucher = await generateVoucher(code);
      setAdmissionVoucher(voucher);
      setVoucherModal(true);
    } catch (error) {
      console.error("Error generating voucher:", error);
      alert("Error generating voucher");
    }
  };

  const generateVoucher = async (voucher_code) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/fee_voucher/get_voucher_by_code_for_print/${voucher_code}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (!response.ok) {
        throw new Error(`Error: ${response.status} ${response.statusText}`);
      }
      const data = await response.json();
      return data.admission_voucher;
    } catch (error) {
      console.error("Error generating voucher:", error);
      throw error;
    }
  };

  // Verify manually paid voucher function
  const handleVerifyVoucher = async (voucher_code) => {
    setLoading(true);
    try {
      const response = await fetch(
        `${BASE_URL}/fee_voucher/verify_manually_paid_voucher`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            voucher_id: voucher_code,
          }),
        }
      );
      const data = await response.json();
      if (response.ok) {
        toast.success("Voucher verified successfully");
        // Refresh the voucher list
        getManualPaidVouchers();
      } else {
        toast.error(data.error || "Failed to verify voucher");
      }
    } catch (error) {
      console.error("Error verifying voucher:", error);
      toast.error("Error verifying voucher");
    } finally {
      setLoading(false);
    }
  };

  const parseVoucherCodes = (rawText) => {
    if (!rawText) return [];
    const tokens = rawText
      .split(/[\s,\t;\r\n]+/)
      .map((t) => t.trim().replace(/^"|"$/g, ""))
      .filter(Boolean)
      .filter((t) => !["voucher_code", "voucher", "code"].includes(t.toLowerCase()));
    return [...new Set(tokens)];
  };

  const handleBulkVoucherSearch = async () => {
    const voucherCodes = parseVoucherCodes(bulkSearchInput);
    if (voucherCodes.length === 0) {
      toast.error("Please paste voucher codes");
      return;
    }
    setBulkSearchLoading(true);
    try {
      const response = await fetch(
        `${BASE_URL}/fee_voucher/get_semester_vouchers_by_codes`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ voucher_codes: voucherCodes }),
        }
      );
      const data = await response.json();
      if (response.ok && Array.isArray(data.vouchers)) {
        setVouchers(data.vouchers);
        if (Array.isArray(data.not_found_codes) && data.not_found_codes.length > 0) {
          toast.warning(
            `Found ${data.vouchers.length} vouchers. Not found: ${data.not_found_codes.length}`
          );
        } else {
          toast.success(`Found ${data.vouchers.length} vouchers`);
        }
        setBulkSearchModalOpen(false);
      } else {
        setVouchers([]);
        toast.error(data.error || "No vouchers found");
      }
    } catch (error) {
      toast.error("Error searching vouchers");
    } finally {
      setBulkSearchLoading(false);
    }
  };

  // Fetch voucher by number
  const fetchVoucher = async () => {
    if (!voucherNumber) {
      toast.error("Please enter a voucher number");
      return;
    }
    setLoading(true);
    try {
      const response = await fetch(
        `${BASE_URL}/fee_voucher/get_semester_voucher_by_code/${voucherNumber}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const data = await response.json();
      if (response.ok && data.vouchers) {
        setVouchers(data.vouchers);
        toast.success("Voucher fetched successfully");
      } else {
        setVouchers([]);
        toast.error(data.error || "Voucher not found");
      }
    } catch (error) {
      toast.error("Error fetching voucher");
    } finally {
      setLoading(false);
    }
  };
const fetchVoucherbyCode = async (code) => {
    if (!code) {
      toast.error("Please enter a voucher number");
      return;
    }
    setLoading(true);
    try {
      const response = await fetch(
        `${BASE_URL}/fee_voucher/get_semester_voucher_by_code/${code}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const data = await response.json();
      if (response.ok && data.vouchers) {
        setVouchers(data.vouchers);
        toast.success("Voucher fetched successfully");
      } else {
        setVouchers([]);
        toast.error(data.error || "Voucher not found");
      }
    } catch (error) {
      toast.error("Error fetching voucher");
    } finally {
      setLoading(false);
    }
  };

  // Fetch all vouchers not pushed to SAP
  const fetchNotPushedVouchers = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        `${BASE_URL}/fee_voucher/get_semester_paid_vouchers`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const data = await response.json();
      if (response.ok && Array.isArray(data.vouchers)) {
        setVouchers(data.vouchers);
        toast.success("Vouchers fetched successfully");
      } else {
        setVouchers([]);
        toast.error(data.error || "No vouchers found");
      }
    } catch (error) {
      toast.error("Error fetching vouchers");
    } finally {
      setLoading(false);
    }
  };

  const getManualPaidVouchers = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        `${BASE_URL}/fee_voucher/get_semester_manual_paid_vouchers`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const data = await response.json();
      if (response.ok && Array.isArray(data.vouchers)) {
        setVouchers(data.vouchers);
        toast.success("Vouchers fetched successfully");
      } else {
        setVouchers([]);
        toast.error(data.error || "No vouchers found");
      }
    } catch (error) {
      toast.error("Error fetching vouchers");
    } finally {
      setLoading(false);
    }
  };

  // Filter paid vouchers by date, bank, and type
  const filterPaidVouchers = async () => {
    if (!filterFromDate || !filterToDate || !filterType) {
      toast.error("Please select date range and type");
      return;
    }
    setLoading(true);
    try {
      // Prepare payload with include_processing when morning is selected
      const payload = {
        from_date: filterFromDate,
        to_date: filterToDate,
        bank: filterBank,
        type: filterType,
        // always include these keys; send "all" when not filtering
        student_type: studentType || "all",
        fine_type: fineType || "all",
      };
      // Include processing applies to morning; when type is "all", it adds processing vouchers alongside both shifts
      if (
        filterType === "semester-fee-morning" ||
        filterType === "all"
      ) {
        payload.include_processing = includeProcessing;
      }
      const response = await fetch(
        `${BASE_URL}/fee_voucher/filter_paid_semester_vouchers`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(payload),
        }
      );
      const data = await response.json();
      if (response.ok && Array.isArray(data.vouchers)) {
        setVouchers(data.vouchers);
        toast.success(`Found ${data.vouchers.length} filtered vouchers`);
        setFilterModalOpen(false);
        // persist filter selections
        try {
          localStorage.setItem(
            "semester_filter_student_type",
            studentType || "all"
          );
          localStorage.setItem("semester_filter_fine_type", fineType || "all");
        } catch (e) {
          // ignore storage errors
        }
        // Reset filter values
        // setFilterFromDate("");
        // setFilterToDate("");
        // setFilterBank("");
        // setFilterType("");
        setIncludeProcessing(false); // Reset include processing
      } else {
        setVouchers([]);
        toast.error(
          data.error || "No vouchers found for the selected criteria"
        );
      }
    } catch (error) {
      toast.error("Error filtering vouchers");
    } finally {
      setLoading(false);
    }
  };

  // New function: Filter paid vouchers not pushed to SAP
  const filterPaidNotPushedVouchers = async () => {
    if (
      !filterNotPushedFromDate ||
      !filterNotPushedToDate ||
      !filterNotPushedType
    ) {
      toast.error("Please select date range and type");
      return;
    }
    setLoading(true);
    try {
      const payload = {
        from_date: filterNotPushedFromDate,
        to_date: filterNotPushedToDate,
        bank: filterNotPushedBank,
        type: filterNotPushedType,
        // always include these keys; send "all" when not filtering
        student_type: filterNotPushedStudentType || "all",
        fine_type: filterNotPushedFineType || "all",
      };
      const response = await fetch(
        `${BASE_URL}/fee_voucher/filter_paid_not_pushed_semester_vouchers`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(payload),
        }
      );
      const data = await response.json();
      if (response.ok && Array.isArray(data.vouchers)) {
        setVouchers(data.vouchers);
        toast.success(
          `Found ${data.vouchers.length} filtered vouchers not pushed to SAP`
        );
        setFilterNotPushedModalOpen(false);
        // persist filter selections for not-pushed modal
        try {
          localStorage.setItem(
            "semester_filter_not_pushed_student_type",
            filterNotPushedStudentType || "all"
          );
          localStorage.setItem(
            "semester_filter_not_pushed_fine_type",
            filterNotPushedFineType || "all"
          );
        } catch (e) {
          // ignore storage errors
        }
        // Reset filter values
        // setFilterNotPushedFromDate("");
        // setFilterNotPushedToDate("");
        // setFilterNotPushedBank("");
        // setFilterNotPushedType("");
      } else {
        setVouchers([]);
        toast.error(
          data.error || "No vouchers found for the selected criteria"
        );
      }
    } catch (error) {
      toast.error("Error filtering vouchers");
    } finally {
      setLoading(false);
    }
  };

  const handleView = (voucher_code) => {
    const voucher = vouchers.find((v) => v.voucher_code === voucher_code);
    if (voucher) {
      setSelectedVoucher(voucher);
      setModalOpen(true);
    } else {
      toast.error("Voucher not found");
    }
  };

  const handleViewAttachment = (attachmentUrl) => {
    if (!attachmentUrl) {
      toast.error("Attachment not available");
      return;
    }
    window.open(attachmentUrl, "_blank", "noopener,noreferrer");
  };

  // Push voucher to SAP (with modal)
  const handlePushToSAP = async (voucher_code) => {
    setLoading(true);
    try {
      const response = await fetch(
        `${BASE_URL}/fee_voucher/push_to_sap_semester_voucher`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ voucher_code }),
        }
      );
      const data = await response.json();
      toast.success("Voucher pushed to SAP successfully");
      fetchVoucherbyCode(voucher_code);
    } catch (error) {
      toast.error("Error pushing voucher to SAP");
    } finally {
      setLoading(false);
    }
  };

  // Cancel voucher
  const handleCancelVoucher = async (voucher) => {
    if (warnIfCancelled(voucher)) return;
    const voucher_code = voucher?.voucher_code;
    setLoading(true);
    try {
      const response = await fetch(
        `${BASE_URL}/fee_voucher/cancel_voucher/${voucher_code}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const data = await response.json();
      if (response.ok) {
        toast.success("Voucher unpaid successfully");
        fetchVoucher();
      } else {
        toast.error(data.error || "Error unpaying voucher");
      }
    } catch (error) {
      toast.error("Error unpaying voucher");
    } finally {
      setLoading(false);
    }
  };

  const handleUnpayVoucher = async (voucher_code) => {
    setLoading(true);
    try {
      const response = await fetch(`${BASE_URL}/fee_voucher/unpay_voucher`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ voucher_id: voucher_code }),
      });
      const data = await response.json();
      if (response.ok) {
        toast.success("Voucher unpaid successfully");
        fetchVoucherbyCode(voucher_code);
      } else {
        toast.error(data.error || "Error unpaying voucher");
      }
    } catch (error) {
      toast.error("Error unpaying voucher");
    } finally {
      setLoading(false);
    }
  };
  const handleBulkPushToSap = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        `${BASE_URL}/fee_voucher/bulk_push_to_sap_semester_vouchers`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            voucher_codes: vouchers.map((v) => v.voucher_code),
          }),
        }
      );
      const data = await response.json();
      if (response.ok) {
        toast.success(
          "Bulk push to SAP successfully process started in background"
        );
      } else {
        toast.error(data.error || "Error in bulk push to SAP");
      }
    } catch (error) {
      toast.error("Error in bulk push to SAP");
    } finally {
      setLoading(false);
    }
  };
  const handleExtendDate = async (voucher) => {
    if (warnIfCancelled(voucher)) return;
    const voucher_code = voucher?.voucher_code;
    setLoading(true);
    try {
      const response = await fetch(
        `${BASE_URL}/fee_voucher/extend_voucher_date`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ voucher_id: voucher_code }),
        }
      );
      const data = await response.json();
      if (response.ok) {
        toast.success("Voucher date extended successfully");
        fetchVoucher();
      } else {
        toast.error(data.error || "Error in extend voucher date");
      }
    } catch (error) {
      toast.error("Error in extend voucher date");
    } finally {
      setLoading(false);
    }
  };

  // Open pay voucher modal
  // 2. Add image conversion function (add this function to your component)
  const convertImageToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
      reader.readAsDataURL(file);
    });
  };

  // 3. Add image upload handler (add this function to your component)
  const handleImageUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;
    // Validate file type
    const allowedTypes = ["image/jpeg", "image/jpg", "image/png", "image/gif"];
    if (!allowedTypes.includes(file.type)) {
      toast.error("Please upload a valid image file (JPEG, PNG, GIF)");
      return;
    }
    // Validate file size (5MB limit)
    const maxSize = 5 * 1024 * 1024; // 5MB in bytes
    if (file.size > maxSize) {
      toast.error("Image size should be less than 5MB");
      return;
    }
    try {
      setPaymentImage(file);
      const base64 = await convertImageToBase64(file);
      setPaymentImageBase64(base64);
      setImagePreview(base64);
      toast.success("Image uploaded successfully");
    } catch (error) {
      toast.error("Error uploading image");
      console.error("Image upload error:", error);
    }
  };

  // 4. Update the handlePayVoucherClick function to reset image states
  const handlePayVoucherClick = (voucher) => {
    if (warnIfCancelled(voucher)) return;
    const voucher_code = voucher?.voucher_code;
    setPayingVoucherCode(voucher_code);
    setSelectedBank("");
    setTransactionId("");
    setPaymentDateTime("");
    setPaymentImage(null);
    setPaymentImageBase64("");
    setImagePreview("");
    setPayModalOpen(true);
  };

  // Pay voucher
  const handlePayVoucher = async () => {
    if (!selectedBank || !transactionId || !paymentDateTime) {
      toast.error("Please fill all required fields");
      return;
    }
    // Validate image is required
    if (!paymentImage || !paymentImageBase64) {
      toast.error("Please upload a payment screenshot/image");
      return;
    }
    setLoading(true);
    try {
      const payload = {
        voucher_id: payingVoucherCode,
        bank: selectedBank,
        transaction_id: transactionId,
        payment_date: paymentDateTime,
        payment_image: paymentImageBase64, // Send base64 image
        image_name: paymentImage.name,
        image_type: paymentImage.type,
      };
      const response = await fetch(
        `${BASE_URL}/fee_voucher/pay_semester_voucher`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(payload),
        }
      );
      const data = await response.json();
      if (response.ok) {
        toast.success("Voucher paid successfully");
        fetchVoucher();
        setPayModalOpen(false);
        // Reset image states
        setPaymentImage(null);
        setPaymentImageBase64("");
        setImagePreview("");
      } else {
        toast.error(data.error || "Error paying voucher");
      }
    } catch (error) {
      toast.error("Error paying voucher");
    } finally {
      setLoading(false);
    }
  };

  // Download CSV template
  const downloadTemplate = () => {
    const csvContent =
      "voucher_code,bank,transaction_id,payment_date,amount\nVOUCHER001,HBL,TXN123456789,2024-01-15T10:30:00,5000\nVOUCHER002,UBL,TXN987654321,2024-01-15T11:45:00,7500";
    const blob = new Blob([csvContent], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "bulk_payment_template.csv";
    a.click();
    window.URL.revokeObjectURL(url);
  };

  // Parse CSV file
  const parseCsvFile = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const text = e.target.result;
          const lines = text.split("\n").filter((line) => line.trim());
          const headers = lines[0].split(",").map((h) => h.trim());
          const requiredHeaders = [
            "voucher_code",
            "bank",
            "transaction_id",
            "payment_date",
            "amount",
          ];
          const missingHeaders = requiredHeaders.filter(
            (h) => !headers.includes(h)
          );
          if (missingHeaders.length > 0) {
            reject(`Missing required columns: ${missingHeaders.join(", ")}`);
            return;
          }
          const data = [];
          const errors = [];
          for (let i = 1; i < lines.length; i++) {
            const values = lines[i].split(",").map((v) => v.trim());
            const row = {};
            headers.forEach((header, index) => {
              row[header] = values[index] || "";
            });
            // Validate required fields
            const rowErrors = [];
            if (!row.voucher_code) rowErrors.push("Voucher code is required");
            if (!row.bank) rowErrors.push("Bank is required");
            if (!BANKS.includes(row.bank))
              rowErrors.push(`Bank must be one of: ${BANKS.join(", ")}`);
            if (!row.transaction_id)
              rowErrors.push("Transaction ID is required");
            if (!row.payment_date) rowErrors.push("Payment date is required");
            if (!row.amount || isNaN(Number.parseFloat(row.amount)))
              rowErrors.push("Valid amount is required");
            if (rowErrors.length > 0) {
              errors.push(`Row ${i + 1}: ${rowErrors.join(", ")}`);
            } else {
              data.push({
                voucher_id: row.voucher_code,
                bank: row.bank,
                transaction_id: row.transaction_id,
                payment_date: row.payment_date,
                amount: Number.parseFloat(row.amount),
              });
            }
          }
          resolve({ data, errors });
        } catch (error) {
          reject("Error parsing CSV file");
        }
      };
      reader.readAsText(file);
    });
  };

  // Handle CSV file upload
  const handleCsvUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;
    if (file.type !== "text/csv" && !file.name.endsWith(".csv")) {
      toast.error("Please upload a CSV file");
      return;
    }
    setCsvFile(file);
    setBulkPayLoading(true);
    try {
      const { data, errors } = await parseCsvFile(file);
      setCsvData(data);
      setCsvErrors(errors);
      if (errors.length > 0) {
        toast.warning(
          `CSV uploaded with ${errors.length} errors. Please review before proceeding.`
        );
      } else {
        toast.success(
          `CSV uploaded successfully. ${data.length} records ready for processing.`
        );
      }
    } catch (error) {
      toast.error(error);
      setCsvData([]);
      setCsvErrors([]);
    } finally {
      setBulkPayLoading(false);
    }
  };

  // Handle bulk pay
  const handleBulkPay = async () => {
    if (csvData.length === 0) {
      toast.error("No valid data to process");
      return;
    }
    if (csvErrors.length > 0) {
      toast.error("Please fix all errors before proceeding");
      return;
    }
    setBulkPayLoading(true);
    try {
      const response = await fetch(
        `${BASE_URL}/fee_voucher/bulk_pay_semester_vouchers`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ payments: csvData }),
        }
      );
      const data = await response.json();
      if (response.ok) {
        toast.success(
          `Bulk payment processed successfully. ${csvData.length} vouchers paid.`
        );
        // setBulkPayModalOpen(false);
        setCsvFile(null);
        setCsvData([]);
        setCsvErrors([]);
        setSuccessVouchers(data.success || []);
        setErrorVouchers(data.errors || []);
        // Refresh the voucher list if needed
        if (vouchers.length > 0) {
          fetchVoucher();
        }
      } else {
        toast.error(data.error || "Error processing bulk payment");
      }
    } catch (error) {
      toast.error("Error processing bulk payment");
    } finally {
      setBulkPayLoading(false);
    }
  };

  const handlePrintVoucher = (voucher_code) => {
    const voucher = vouchers.find((v) => v.voucher_code === voucher_code);
    if (voucher) {
      window.open(`/admissions/fee-voucher/${voucher.url_token}`, "_blank");
    }
  };

  // Reset bulk pay modal
  const resetBulkPayModal = () => {
    setBulkPayModalOpen(false);
    setCsvFile(null);
    setCsvData([]);
    setCsvErrors([]);
  };

  // Reset filter modal
  const resetFilterModal = () => {
    setFilterModalOpen(false);
    setFilterFromDate("");
    setFilterToDate("");
    setFilterBank("");
    setFilterType("all");
    setIncludeProcessing(false); // Reset include processing checkbox
    // Reset new filters
    setStudentType("all");
    setFineType("all");
    try {
      localStorage.removeItem("semester_filter_student_type");
      localStorage.removeItem("semester_filter_fine_type");
    } catch (e) {
      // ignore
    }
  };

  // Reset filter not pushed modal
  const resetFilterNotPushedModal = () => {
    setFilterNotPushedModalOpen(false);
    // setFilterNotPushedFromDate("");
    // setFilterNotPushedToDate("");
    // setFilterNotPushedBank("");
    // setFilterNotPushedType("");
    // Reset new filters
    setFilterNotPushedStudentType("all");
    setFilterNotPushedFineType("all");
    try {
      localStorage.removeItem("semester_filter_not_pushed_student_type");
      localStorage.removeItem("semester_filter_not_pushed_fine_type");
    } catch (e) {
      // ignore
    }
  };

  const handleViewLogsClick = (voucher) => {
    let main_voucher = vouchers.find(
      (v) => v.voucher_code === voucher.voucher_code
    );
    setSelectedVoucherForLogs(main_voucher);
    setViewLogsModalOpen(true);
  };

  // Table columns
  const columns = [
    { Header: "Voucher Code", accessor: "voucher_code", align: "center" },
    {
      Header: "Is Paid",
      accessor: "is_paid",
      align: "center",
      Cell: ({ value }) => (
        <MDBadge
          badgeContent={value === 1 ? "Paid" : "Not Paid"}
          color={value === 1 ? "success" : "warning"}
          variant="gradient"
          size="sm"
        />
      ),
    },
    { Header: "Due Date", accessor: "due_date", align: "center" },
    { Header: "Amount", accessor: "amount", align: "center" },
    { Header: "Transaction ID", accessor: "transaction_id", align: "center" },
    { Header: "Payment Date", accessor: "payment_date", align: "center" },
    { Header: "Form No", accessor: "form_no", align: "center" },
    { Header: "Applicant Name", accessor: "name", align: "center" },
    { Header: "Applicant Phone", accessor: "phone", align: "center" },
    { Header: "Applicant CNIC", accessor: "cnic", align: "center" },
    { Header: "BP NO", accessor: "bp_no", align: "center" },
    { Header: "Program", accessor: "program", align: "center" },
    { Header: "Department", accessor: "department", align: "center" },
    { Header: "Cost Center", accessor: "cost_center", align: "center" },
    { Header: "Payment Id", accessor: "payment_id", align: "center" },
    {
      Header: "Payment Mode",
      accessor: "payment_mode",
      align: "center",
      Cell: ({ row }) =>
        isVoucherCancelled(row.original) ? (
          <MDBadge
            badgeContent="Cancelled"
            color="error"
            variant="gradient"
            size="sm"
          />
        ) : (
          row.original.payment_mode || "N/A"
        ),
    },
    { Header: "Manual Paid By", accessor: "manual_paid_by", align: "center" },
    { Header: "Last Performed By", accessor: "last_performed_by", align: "center" },
    {
      Header: "Bank",
      accessor: "bank",
      align: "center",
      Cell: ({ value }) => (value ? value : "N/A"),
    },
    {
      Header: "SAP Status",
      accessor: "is_added_to_sap",
      align: "center",
      Cell: ({ value }) => (
        <MDBadge
          badgeContent={value === 1 ? "Pushed" : "Not Pushed"}
          color={value === 1 ? "success" : "error"}
          variant="gradient"
          size="sm"
        />
      ),
    },
    {
      Header: "Actions",
      accessor: "actions",
      align: "center",
      Cell: ({ row }) => (
        <>
          {hasAdmissionPermission("SemesterVouchers", "UPDATE") && (
            <MDBox
              display="flex"
              gap={1}
              justifyContent="center"
              flexWrap="wrap"
            >
              {row.original.is_paid === 1 ? (
                <Button
                  variant="contained"
                  color="warning"
                  size="small"
                  disabled={loading}
                  onClick={() =>
                    handleUnpayVoucher(row.original.voucher_code)
                  }
                  sx={{ minWidth: "60px", fontSize: "0.75rem" }}
                >
                  Unpay
                </Button>
              ) : (
                <Button
                  variant="contained"
                  color="success"
                  size="small"
                  disabled={loading}
                  onClick={() =>
                    handlePayVoucherClick(row.original)
                  }
                  sx={{ minWidth: "60px", fontSize: "0.75rem" }}
                >
                  Pay
                </Button>
              )}
              {/* Verify Voucher Button - Only show when payment_mode = Manual */}
              {row.original.payment_mode === "Manual" &&
                hasAdmissionPermission("SemesterVouchers", "MANAGE") && (
                  <Button
                    variant="contained"
                    color="info"
                    size="small"
                    disabled={loading}
                    onClick={() =>
                      handleVerifyVoucher(row.original.voucher_code)
                    }
                    sx={{ minWidth: "60px", fontSize: "0.75rem" }}
                    startIcon={<VerifiedIcon />}
                    style={{ color: "black" }}
                  >
                    Verify
                  </Button>
                )}
              {hasAdmissionPermission("SemesterVouchers", "MANAGE") && (
                <Button
                  variant="contained"
                  color="primary"
                  size="small"
                  disabled={loading}
                  onClick={() => handleViewLogsClick(row.original)}
                  sx={{ minWidth: "60px", fontSize: "0.75rem" }}
                  startIcon={<VisibilityIcon />}
                  style={{ color: "white" }}
                >
                  View Logs
                </Button>
              )}
              {hasAdmissionPermission("SemesterVouchers", "MANAGE") &&
                row.original.is_paid == 1 &&
                row.original.is_added_to_sap != 1 && (
                  <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    disabled={loading}
                    onClick={() => handlePushToSAP(row.original.voucher_code)}
                    style={{ color: "white" }}
                    sx={{ minWidth: "60px", fontSize: "0.75rem" }}
                  >
                    Push to Sap
                  </Button>
                )}
              {row.original.has_manual_payment_attachment && (
                <Button
                  variant="contained"
                  color="info"
                  size="small"
                  onClick={() =>
                    handleViewAttachment(row.original.manual_payment_attachment)
                  }
                  sx={{ minWidth: "60px", fontSize: "0.75rem" }}
                  style={{ color: "black" }}
                  startIcon={<AttachFileIcon />}
                >
                  View Attachment
                </Button>
              )}
            </MDBox>
          )}
          {hasAdmissionPermission("SemesterVouchers", "UPDATE") &&
            row.original.is_paid === 0 && (
              <>
                <Button
                  variant="contained"
                  color="secondary"
                  size="small"
                  onClick={() => handleExtendDate(row.original)}
                  sx={{ minWidth: "60px", fontSize: "0.75rem" }}
                  style={{ marginTop: "10px", color: "white" }}
                >
                  Extend 2 days
                </Button>
                <Button
                  variant="contained"
                  color="secondary"
                  size="small"
                  onClick={() => handleOpenUpdateModal(row.original)}
                  sx={{ minWidth: "60px", fontSize: "0.75rem" }}
                  style={{
                    marginTop: "10px",
                    color: "white",
                    marginLeft: "5px",
                  }}
                >
                  Update Fee
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  size="small"
                  onClick={() => handleCancelVoucher(row.original)}
                  sx={{ minWidth: "60px", fontSize: "0.75rem" }}
                  style={{
                    marginTop: "10px",
                    color: "white",
                    marginLeft: "5px",
                    marginRight: "5px",
                  }}
                >
                  Cancel
                </Button>
              </>
            )}
          {hasAdmissionPermission("SemesterVouchers", "READ") && (
            <>
              <Button
                variant="contained"
                color="secondary"
                size="small"
                onClick={() => handlePrintVoucher(row.original.voucher_code)}
                sx={{ minWidth: "60px", fontSize: "0.75rem" }}
                style={{ marginTop: "10px", color: "white" }}
              >
                Print Voucher
              </Button>
            </>
          )}
        </>
      ),
    },
  ];

  // Table rows
  const rows = vouchers.map((v) => ({
    voucher_code: v.voucher_code,
    is_paid: v.is_paid,
    due_date: new Date(v.due_date).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "long",
      year: "numeric",
      timeZone: "Asia/Karachi",
    }),
    amount: v.amount,
    transaction_id: v.transaction_id,
    payment_date: v.payment_date,
    form_no: v.application_form_id,
    name: v.user_name,
    phone: v.phone,
    cnic: v.cnic,
    is_added_to_sap: v.is_added_to_sap,
    bp_no: v.bp_no, // Added BP NO to the row data
    program: v.program_name, // Added program name to the row data
    department: v.department_name, // Added department name to the row data
    cost_center: v.cost_center, // Added cost center to the row data
    payment_id: v.payment_id, // Added payment_mode to the row data
    payment_mode: v.payment_mode || "N/A",
    is_cancel: v.is_cancel,
    manual_paid_by: v.manual_paid_by || "N/A",
    last_performed_by: v.last_performed_by_name || "N/A" , // Added last performed by to the row data
    manual_payment_attachment: v.manual_payment_attachment,
    has_manual_payment_attachment: v.has_manual_payment_attachment,
    actions: v, // pass the whole voucher for actions
  }));

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <ToastContainer />
      <MDBox pb={3}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Card className="mb-4">
              <MDBox p={3}>
                <MDTypography variant="h5" fontWeight="medium" mb={2}>
                  Semester Voucher Management
                </MDTypography>
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={12} md={2}>
                    <Paper
                      component="form"
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        width: "100%",
                      }}
                    >
                      <InputBase
                        sx={{ ml: 1, flex: 1, fontSize: "16px" }}
                        placeholder="Voucher Number"
                        inputProps={{ "aria-label": "voucher number" }}
                        value={voucherNumber}
                        onChange={(e) => setVoucherNumber(e.target.value)}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            e.preventDefault();
                            fetchVoucher();
                          }
                        }}
                      />
                    </Paper>
                  </Grid>
                  <Grid item xs={12} md={2}>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={fetchVoucher}
                      disabled={loading}
                      style={{ color: "white", width: "100%" }}
                    >
                      {loading ? (
                        <CircularProgress size={20} color="inherit" />
                      ) : (
                        "Fetch Voucher"
                      )}
                    </Button>
                  </Grid>
                  <Grid item xs={12} md={2}>
                    <Button
                      variant="contained"
                      color="info"
                      onClick={() => setBulkSearchModalOpen(true)}
                      disabled={loading}
                      style={{ color: "black", width: "100%" }}
                    >
                      Multiple Search
                    </Button>
                  </Grid>
                  <Grid item xs={12} md={2}>
                    {hasAdmissionPermission("SemesterVouchers", "MANAGE") && (
                      <Button
                        variant="contained"
                        color="secondary"
                        onClick={fetchNotPushedVouchers}
                        disabled={loading}
                        style={{ color: "white", width: "100%" }}
                      >
                        {loading ? (
                          <CircularProgress size={20} color="inherit" />
                        ) : (
                          "Fetch All Paid Not Pushed to SAP"
                        )}
                      </Button>
                    )}
                  </Grid>
                  <Grid item xs={12} md={2}>
                    {hasAdmissionPermission("SemesterVouchers", "UPDATE") && (
                      <Button
                        variant="contained"
                        color="info"
                        onClick={() => setFilterModalOpen(true)}
                        disabled={loading}
                        style={{ color: "black", width: "100%" }}
                        startIcon={<FilterListIcon />}
                      >
                        Filter Paid
                      </Button>
                    )}
                  </Grid>
                  <Grid item xs={12} md={2}>
                    {hasAdmissionPermission("SemesterVouchers", "MANAGE") && (
                      <Button
                        variant="contained"
                        color="warning"
                        onClick={() => setFilterNotPushedModalOpen(true)}
                        disabled={loading}
                        style={{ color: "black", width: "100%" }}
                        startIcon={<FilterListIcon />}
                      >
                        Filter Paid Not Pushed to SAP
                      </Button>
                    )}
                  </Grid>
                  <Grid item xs={12} md={2}>
                    {hasAdmissionPermission("SemesterVouchers", "UPDATE") && (
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={() => setBulkPayModalOpen(true)}
                        disabled={loading}
                        style={{ color: "white", width: "100%" }}
                        startIcon={<CloudUploadIcon />}
                      >
                        Bulk Pay
                      </Button>
                    )}
                  </Grid>
                  <Grid item xs={12} md={2}>
                    {hasAdmissionPermission("SemesterVouchers", "MANAGE") && (
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={() => handleBulkPushToSap()}
                        disabled={!vouchers || vouchers.length === 0}
                        style={{ color: "white", width: "100%" }}
                        startIcon={<CloudUploadIcon />}
                      >
                        Push to SAP (Bulk)
                      </Button>
                    )}
                  </Grid>
                  <Grid item xs={12} md={2}>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={downloadTemplate}
                      style={{ width: "100%", color: "white" }}
                      startIcon={<DownloadIcon />}
                    >
                      Template
                    </Button>
                  </Grid>
                  <Grid item xs={12} md={10}></Grid>
                  <Grid item xs={12} md={2}>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={getManualPaidVouchers}
                      style={{ width: "100%", color: "white" }}
                    >
                      GET Manual Paid Vouchers
                    </Button>
                  </Grid>
                  <Grid item xs={12} md={2}>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={exportVouchers}
                      disabled={!vouchers || vouchers.length === 0}
                      style={{ width: "100%", color: "white" }}
                    >
                      Export Vouchers
                    </Button>
                  </Grid>
                </Grid>
              </MDBox>
            </Card>
            <Card>
              <MDBox pt={3} pb={3}>
                {loading ? (
                  <MDBox display="flex" justifyContent="center" p={5}>
                    <CircularProgress />
                  </MDBox>
                ) : vouchers && vouchers.length > 0 ? (
                  <DataTable
                    table={{ columns, rows }}
                    isSorted={false}
                    entriesPerPage={false}
                    showTotalEntries={false}
                    noEndBorder
                  />
                ) : (
                  <MDBox
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    p={5}
                  >
                    <MDTypography variant="body1" mt={2}>
                      No vouchers found. Please search or fetch to see results.
                    </MDTypography>
                  </MDBox>
                )}
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>

      {/* View Voucher Modal */}
      <Dialog
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Voucher SAP Response</DialogTitle>
        <DialogContent>
          {selectedVoucher ? (
            <>
              <MDTypography variant="subtitle1" fontWeight="medium" mb={1}>
                Voucher Code: {selectedVoucher.voucher_code}
              </MDTypography>
              <MDTypography variant="body2" mb={2}>
                <strong>SAP Response:</strong>
                <br />
                <pre
                  style={{
                    whiteSpace: "pre-wrap",
                    wordBreak: "break-word",
                    background: "#f9f9f9",
                    padding: "10px",
                    borderRadius: "6px",
                  }}
                >
                  {selectedVoucher.sap_response || "No response available"}
                </pre>
              </MDTypography>
            </>
          ) : null}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setModalOpen(false)} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>

      {/* Pay Voucher Modal */}
      <Dialog
        open={payModalOpen}
        onClose={() => setPayModalOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Pay Voucher</DialogTitle>
        <DialogContent>
          <MDBox mt={2}>
            <FormControl fullWidth margin="normal">
              <InputLabel>Select Bank</InputLabel>
              <Select
                value={selectedBank}
                onChange={(e) => setSelectedBank(e.target.value)}
                label="Select Bank"
                style={{
                  height: "35px",
                }}
              >
                {BANKS.map((bank) => (
                  <MenuItem key={bank} value={bank}>
                    {bank}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <TextField
              fullWidth
              margin="normal"
              label="Transaction ID"
              value={transactionId}
              onChange={(e) => setTransactionId(e.target.value)}
              required
            />
            <TextField
              fullWidth
              margin="normal"
              label="Payment Date & Time"
              type="datetime-local"
              value={paymentDateTime}
              onChange={(e) => setPaymentDateTime(e.target.value)}
              InputLabelProps={{
                shrink: true,
              }}
              required
            />
            {/* Image Upload Section */}
            <Box sx={{ mt: 2, mb: 2 }}>
              <MDTypography variant="body2" mb={1} fontWeight="medium">
                Payment Screenshot/Image *
              </MDTypography>
              <input
                accept="image/*"
                style={{ display: "none" }}
                id="payment-image-upload"
                type="file"
                onChange={handleImageUpload}
              />
              <label htmlFor="payment-image-upload">
                <Button
                  variant="contained"
                  component="span"
                  startIcon={<AttachFileIcon />}
                  fullWidth
                  style={{ color: "white" }}
                  sx={{ mb: 1, height: "40px" }}
                >
                  {paymentImage ? paymentImage.name : "Choose Payment Image"}
                </Button>
              </label>
              {/* Image Preview */}
              {imagePreview && (
                <Box sx={{ mt: 2, position: "relative" }}>
                  <img
                    src={imagePreview || "/placeholder.svg"}
                    alt="Payment Preview"
                    style={{
                      width: "100%",
                      maxHeight: "200px",
                      objectFit: "contain",
                      border: "1px solid #ddd",
                      borderRadius: "4px",
                    }}
                  />
                  <IconButton
                    onClick={() => {
                      setPaymentImage(null);
                      setPaymentImageBase64("");
                      setImagePreview("");
                    }}
                    sx={{
                      position: "absolute",
                      top: 5,
                      right: 5,
                      backgroundColor: "rgba(255, 255, 255, 0.8)",
                      "&:hover": {
                        backgroundColor: "rgba(255, 255, 255, 0.9)",
                      },
                    }}
                    size="small"
                  >
                    <DeleteIcon />
                  </IconButton>
                </Box>
              )}
              <MDTypography variant="caption" color="text.secondary" mt={1}>
                Supported formats: JPEG, PNG, GIF (Max size: 5MB)
              </MDTypography>
            </Box>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setPayModalOpen(false)} color="secondary">
            Cancel
          </Button>
          <Button
            onClick={handlePayVoucher}
            color="primary"
            variant="contained"
            disabled={
              loading ||
              !selectedBank ||
              !transactionId ||
              !paymentDateTime ||
              !paymentImage
            }
            style={{ color: "white" }}
          >
            {loading ? <CircularProgress size={20} color="inherit" /> : "Pay"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Filter Paid Vouchers Modal */}
      <Dialog
        open={filterModalOpen}
        onClose={resetFilterModal}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Filter Paid Vouchers</DialogTitle>
        <DialogContent>
          <MDBox mt={2}>
            <TextField
              fullWidth
              margin="normal"
              label="Select From Date"
              type="date"
              value={filterFromDate}
              onChange={(e) => setFilterFromDate(e.target.value)}
              InputLabelProps={{
                shrink: true,
              }}
              required
            />
            <TextField
              fullWidth
              margin="normal"
              label="Select To Date"
              type="date"
              value={filterToDate}
              onChange={(e) => setFilterToDate(e.target.value)}
              InputLabelProps={{
                shrink: true,
              }}
              required
            />
            <FormControl fullWidth margin="normal">
              <InputLabel>Select Bank (Optional)</InputLabel>
              <Select
                value={filterBank}
                onChange={(e) => setFilterBank(e.target.value)}
                label="Select Bank (Optional)"
                style={{
                  height: "35px",
                }}
              >
                <MenuItem value="">
                  <em>All Banks</em>
                </MenuItem>
                {BANKS.map((bank) => (
                  <MenuItem key={bank} value={bank}>
                    {bank}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            {/* Student Type Filter */}
            <FormControl fullWidth margin="normal">
              <InputLabel>Student Type</InputLabel>
              <Select
                value={studentType}
                onChange={(e) => setStudentType(e.target.value)}
                label="Student Type"
                style={{ height: "35px" }}
              >
                <MenuItem value="all">All</MenuItem>
                <MenuItem value="old">Old Student</MenuItem>
                <MenuItem value="new">New Student</MenuItem>
              </Select>
            </FormControl>
            {/* Fine Status Filter */}
            <FormControl fullWidth margin="normal">
              <InputLabel>Fine Status</InputLabel>
              <Select
                value={fineType}
                onChange={(e) => setFineType(e.target.value)}
                label="Fine Status"
                style={{ height: "35px" }}
              >
                <MenuItem value="all">All</MenuItem>
                <MenuItem value="with_fine">With Fine</MenuItem>
                <MenuItem value="without_fine">Without Fine</MenuItem>
              </Select>
            </FormControl>
            <FormControl fullWidth margin="normal">
              <InputLabel>Select Type</InputLabel>
              <Select
                value={filterType}
                onChange={(e) => setFilterType(e.target.value)}
                label="Select Type"
                style={{
                  height: "35px",
                }}
              >
                {VOUCHER_TYPES.map((type) => (
                  <MenuItem key={type.value} value={type.value}>
                    {type.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            {/* Include Processing — morning-only flow; also offered when "All" is selected */}
            {(filterType === "semester-fee-morning" ||
              filterType === "all") && (
              <FormControlLabel
                control={
                  <Checkbox
                    checked={includeProcessing}
                    onChange={(e) => setIncludeProcessing(e.target.checked)}
                    color="primary"
                  />
                }
                label="Include Processing"
                sx={{ mt: 2, mb: 1 }}
              />
            )}
          </MDBox>
        </DialogContent>
        <DialogActions>
          <Button onClick={resetFilterModal} color="secondary">
            Cancel
          </Button>
          <Button
            onClick={filterPaidVouchers}
            color="primary"
            variant="contained"
            disabled={
              loading ||
              !filterToDate ||
              !filterFromDate ||
              !filterType
            }
            style={{ color: "white" }}
          >
            {loading ? (
              <CircularProgress size={20} color="inherit" />
            ) : (
              "Filter"
            )}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Filter Paid Not Pushed to SAP Modal */}
      <Dialog
        open={filterNotPushedModalOpen}
        onClose={resetFilterNotPushedModal}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Filter Paid Vouchers Not Pushed to SAP</DialogTitle>
        <DialogContent>
          <MDBox mt={2}>
            <TextField
              fullWidth
              margin="normal"
              label="Select From Date"
              type="date"
              value={filterNotPushedFromDate}
              onChange={(e) => setFilterNotPushedFromDate(e.target.value)}
              InputLabelProps={{
                shrink: true,
              }}
              required
            />
            <TextField
              fullWidth
              margin="normal"
              label="Select To Date"
              type="date"
              value={filterNotPushedToDate}
              onChange={(e) => setFilterNotPushedToDate(e.target.value)}
              InputLabelProps={{
                shrink: true,
              }}
              required
            />
            <FormControl fullWidth margin="normal">
              <InputLabel>Select Bank (Optional)</InputLabel>
              <Select
                value={filterNotPushedBank}
                onChange={(e) => setFilterNotPushedBank(e.target.value)}
                label="Select Bank (Optional)"
                style={{
                  height: "35px",
                }}
              >
                <MenuItem value="">
                  <em>All Banks</em>
                </MenuItem>
                {BANKS.map((bank) => (
                  <MenuItem key={bank} value={bank}>
                    {bank}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            {/* Student Type Filter (Not Pushed) */}
            <FormControl fullWidth margin="normal">
              <InputLabel>Student Type</InputLabel>
              <Select
                value={filterNotPushedStudentType}
                onChange={(e) => setFilterNotPushedStudentType(e.target.value)}
                label="Student Type"
                style={{ height: "35px" }}
              >
                <MenuItem value="all">All</MenuItem>
                <MenuItem value="old">Old Student</MenuItem>
                <MenuItem value="new">New Student</MenuItem>
              </Select>
            </FormControl>
            {/* Fine Status Filter (Not Pushed) */}
            <FormControl fullWidth margin="normal">
              <InputLabel>Fine Status</InputLabel>
              <Select
                value={filterNotPushedFineType}
                onChange={(e) => setFilterNotPushedFineType(e.target.value)}
                label="Fine Status"
                style={{ height: "35px" }}
              >
                <MenuItem value="all">All</MenuItem>
                <MenuItem value="with_fine">With Fine</MenuItem>
                <MenuItem value="without_fine">Without Fine</MenuItem>
              </Select>
            </FormControl>
            <FormControl fullWidth margin="normal">
              <InputLabel>Select Type</InputLabel>
              <Select
                value={filterNotPushedType}
                onChange={(e) => setFilterNotPushedType(e.target.value)}
                label="Select Type"
                style={{
                  height: "35px",
                }}
              >
                {VOUCHER_TYPES.map((type) => (
                  <MenuItem key={type.value} value={type.value}>
                    {type.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <Button onClick={resetFilterNotPushedModal} color="secondary">
            Cancel
          </Button>
          <Button
            onClick={filterPaidNotPushedVouchers}
            color="primary"
            variant="contained"
            disabled={
              loading ||
              !filterNotPushedToDate ||
              !filterNotPushedFromDate ||
              !filterNotPushedType
            }
            style={{ color: "white" }}
          >
            {loading ? (
              <CircularProgress size={20} color="inherit" />
            ) : (
              "Filter"
            )}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={bulkSearchModalOpen}
        onClose={() => setBulkSearchModalOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Search Multiple Semester Vouchers</DialogTitle>
        <DialogContent>
          <MDBox mt={2}>
            <TextField
              fullWidth
              multiline
              minRows={6}
              label="Paste voucher codes / CSV column"
              value={bulkSearchInput}
              onChange={(e) => setBulkSearchInput(e.target.value)}
              placeholder={"Example:\n200001\n200002\n200003"}
            />
          </MDBox>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setBulkSearchModalOpen(false)} color="secondary">
            Cancel
          </Button>
          <Button
            onClick={handleBulkVoucherSearch}
            color="primary"
            variant="contained"
            disabled={bulkSearchLoading}
            style={{ color: "black" }}
          >
            {bulkSearchLoading ? (
              <CircularProgress size={20} color="inherit" />
            ) : (
              "Search"
            )}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Bulk Pay Modal */}
      <Dialog
        open={bulkPayModalOpen}
        onClose={resetBulkPayModal}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>Bulk Payment Upload</DialogTitle>
        <DialogContent>
          <MDBox mt={2}>
            {/* Instructions */}
            <Alert severity="info" sx={{ mb: 3 }}>
              <AlertTitle>Instructions for Bulk Payment</AlertTitle>
              <MDTypography variant="body2" mb={1}>
                1. Download the CSV template using the Template button
              </MDTypography>
              <MDTypography variant="body2" mb={1}>
                2. Fill in the required columns: voucher_code, bank,
                transaction_id, payment_date, amount
              </MDTypography>
              <MDTypography variant="body2" mb={1}>
                3. Bank must be one of: {BANKS.join(", ")}
              </MDTypography>
              <MDTypography variant="body2" mb={1}>
                4. Payment date format: YYYY-MM-DDTHH:MM:SS (e.g.,
                2024-01-15T10:30:00)
              </MDTypography>
              <MDTypography variant="body2">
                5. Upload the modified CSV file and click Process Bulk Payment
              </MDTypography>
            </Alert>
            {/* File Upload */}
            <Box sx={{ mb: 3 }}>
              <input
                accept=".csv"
                style={{ display: "none" }}
                id="csv-upload"
                type="file"
                onChange={handleCsvUpload}
              />
              <label htmlFor="csv-upload">
                <Button
                  variant="contained"
                  component="span"
                  startIcon={<CloudUploadIcon />}
                  style={{ color: "white" }}
                  fullWidth
                  sx={{ mb: 2, height: "50px" }}
                >
                  {csvFile ? csvFile.name : "Choose CSV File"}
                </Button>
              </label>
            </Box>
            {/* Loading indicator for CSV processing */}
            {bulkPayLoading && !csvData.length && !csvErrors.length && (
              <Box display="flex" justifyContent="center" my={2}>
                <CircularProgress />
                <MDTypography variant="body2" ml={2}>
                  Processing CSV file...
                </MDTypography>
              </Box>
            )}
            {/* Data preview */}
            {csvData.length > 0 && (
              <Alert severity="success" sx={{ mb: 2 }}>
                <AlertTitle>CSV Data Preview</AlertTitle>
                <MDTypography variant="body2" mb={1}>
                  Successfully parsed {csvData.length} records
                </MDTypography>
                <div
                  style={{
                    maxHeight: "200px",
                    overflow: "auto",
                    mt: 2,
                    minWidth: "500px",
                  }}
                >
                  <table
                    style={{
                      width: "500px",
                      fontSize: "12px",
                      borderCollapse: "collapse",
                    }}
                  >
                    <thead>
                      <tr style={{ backgroundColor: "#f5f5f5" }}>
                        <th
                          style={{ border: "1px solid #ddd", padding: "4px" }}
                        >
                          Voucher Code
                        </th>
                        <th
                          style={{ border: "1px solid #ddd", padding: "4px" }}
                        >
                          Bank
                        </th>
                        <th
                          style={{ border: "1px solid #ddd", padding: "4px" }}
                        >
                          Transaction ID
                        </th>
                        <th
                          style={{ border: "1px solid #ddd", padding: "4px" }}
                        >
                          Payment Date
                        </th>
                        <th
                          style={{ border: "1px solid #ddd", padding: "4px" }}
                        >
                          Amount
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {csvData.map((row, index) => (
                        <tr key={index}>
                          <td
                            style={{ border: "1px solid #ddd", padding: "4px" }}
                          >
                            {row.voucher_id}
                          </td>
                          <td
                            style={{ border: "1px solid #ddd", padding: "4px" }}
                          >
                            {row.bank}
                          </td>
                          <td
                            style={{ border: "1px solid #ddd", padding: "4px" }}
                          >
                            {row.transaction_id}
                          </td>
                          <td
                            style={{ border: "1px solid #ddd", padding: "4px" }}
                          >
                            {row.payment_date}
                          </td>
                          <td
                            style={{ border: "1px solid #ddd", padding: "4px" }}
                          >
                            {row.amount}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </Alert>
            )}
            {/* Errors display */}
            {csvErrors.length > 0 && (
              <Alert severity="error" sx={{ mb: 2 }}>
                <AlertTitle>CSV Validation Errors</AlertTitle>
                <div
                  className="box"
                  style={{
                    maxHeight: "200px",
                    overflow: "auto",
                    minWidth: "500px",
                  }}
                >
                  {csvErrors.map((error, index) => (
                    <MDTypography key={index} variant="body2" sx={{ mb: 0.5 }}>
                      • {error}
                    </MDTypography>
                  ))}
                </div>
              </Alert>
            )}
            {successVouchers.length > 0 && (
              <Alert severity="success" sx={{ mb: 2 }}>
                <AlertTitle>Successful Payments</AlertTitle>
                <div
                  className="box"
                  style={{
                    maxHeight: "200px",
                    overflow: "auto",
                    minWidth: "500px",
                  }}
                >
                  {successVouchers.map((voucher, index) => (
                    <MDTypography key={index} variant="body2" sx={{ mb: 0.5 }}>
                      • {voucher} - Paid
                    </MDTypography>
                  ))}
                </div>
              </Alert>
            )}
            {errorVouchers.length > 0 && (
              <Alert severity="error" sx={{ mb: 2 }}>
                <AlertTitle>Failed Payments</AlertTitle>
                <div
                  className="box"
                  style={{
                    maxHeight: "200px",
                    overflow: "auto",
                    minWidth: "500px",
                  }}
                >
                  {errorVouchers.map((voucher, index) => (
                    <MDTypography key={index} variant="body2" sx={{ mb: 0.5 }}>
                      • {voucher.voucher_id} -{" "}
                      {voucher.error || "Unknown error"}
                    </MDTypography>
                  ))}
                </div>
              </Alert>
            )}
          </MDBox>
        </DialogContent>
        <DialogActions>
          <Button onClick={resetBulkPayModal} color="secondary">
            Cancel
          </Button>
          <Button
            onClick={handleBulkPay}
            color="primary"
            variant="contained"
            disabled={
              bulkPayLoading || csvData.length === 0 || csvErrors.length > 0
            }
            style={{ color: "white" }}
          >
            {bulkPayLoading ? (
              <CircularProgress size={20} color="inherit" />
            ) : (
              "Process Bulk Payment"
            )}
          </Button>
        </DialogActions>
      </Dialog>

      <VoucherDialog
        voucherModal={voucherModal}
        handleCloseVoucherModal={handleCloseVoucherModal}
        admissionVoucher={admissionVoucher}
      />

      <Dialog
        open={cancelledWarningOpen}
        onClose={() => setCancelledWarningOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          <MDBox display="flex" alignItems="center" gap={1}>
            <WarningAmberIcon color="warning" />
            Cancelled Voucher
          </MDBox>
        </DialogTitle>
        <DialogContent>
          <Alert severity="warning" sx={{ mt: 1 }}>
            <AlertTitle>This voucher is cancelled</AlertTitle>
            Voucher{" "}
            <strong>
              {cancelledWarningVoucher?.voucher_code || ""}
            </strong>{" "}
            has already been cancelled and cannot be edited.
          </Alert>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setCancelledWarningOpen(false)}
            color="primary"
            variant="contained"
            style={{ color: "white" }}
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={updateModalOpen}
        onClose={() => setUpdateModalOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Update Voucher Amount</DialogTitle>
        <DialogContent>
          <TextField
            fullWidth
            label="New Amount"
            type="number"
            value={amountToUpdate}
            onChange={(e) => setAmountToUpdate(e.target.value)}
            margin="normal"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setUpdateModalOpen(false)} color="secondary">
            Cancel
          </Button>
          <Button
            onClick={handleUpdateAmount}
            color="primary"
            variant="contained"
            style={{ color: "white" }}
          >
            Update Fee
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={viewLogsModalOpen}
        onClose={() => setViewLogsModalOpen(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          <MDTypography variant="h6" fontWeight="medium">
            View Logs - {selectedVoucherForLogs?.voucher_code}
          </MDTypography>
        </DialogTitle>
        <DialogContent>
          {selectedVoucherForLogs ? (
            <>
              <MDTypography variant="subtitle1" fontWeight="medium" mb={2}>
                Voucher Code: {selectedVoucherForLogs.voucher_code}
              </MDTypography>
{/* BP Creation Response */}
              <MDTypography variant="subtitle2" fontWeight="medium" mb={1}>
                BP Creation Response:
              </MDTypography>
              <MDBox mb={3}>
                <pre
                  style={{
                    whiteSpace: "pre-wrap",
                    wordBreak: "break-word",
                    background: "#f9f9f9",
                    padding: "15px",
                    borderRadius: "8px",
                    border: "1px solid #e0e0e0",
                    fontSize: "12px",
                    maxHeight: "200px",
                    overflow: "auto",
                  }}
                >
                  {selectedVoucherForLogs.bp_response ||
                    "No BP creation response available"}
                </pre>
              </MDBox>
              {/* Invoice SAP Response */}
              <MDTypography variant="subtitle2" fontWeight="medium" mb={1}>
                Invoice SAP Response:
              </MDTypography>
              <MDBox mb={3}>
                <pre
                  style={{
                    whiteSpace: "pre-wrap",
                    wordBreak: "break-word",
                    background: "#f9f9f9",
                    padding: "15px",
                    borderRadius: "8px",
                    border: "1px solid #e0e0e0",
                    fontSize: "12px",
                    maxHeight: "200px",
                    overflow: "auto",
                  }}
                >
                  {selectedVoucherForLogs.sap_response ||
                    "No invoice response available"}
                </pre>
              </MDBox>

              {/* Payment SAP Response */}
              <MDTypography variant="subtitle2" fontWeight="medium" mb={1}>
                Payment SAP Response:
              </MDTypography>
              <MDBox>
                <pre
                  style={{
                    whiteSpace: "pre-wrap",
                    wordBreak: "break-word",
                    background: "#f0f8ff",
                    padding: "15px",
                    borderRadius: "8px",
                    border: "1px solid #b3d9ff",
                    fontSize: "12px",
                    maxHeight: "200px",
                    overflow: "auto",
                  }}
                >
                  {selectedVoucherForLogs.sap_response_invoice ||
                    "No payment response available"}
                </pre>
              </MDBox>
            </>
          ) : null}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setViewLogsModalOpen(false)} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </DashboardLayout>
  );
}

export default SemesterVouchers;
